import * as Backbone from "backbone";
import _ from "lodash";
import {ManageView} from "module/selpan/menu/ManageView";
import {fromViewName, toViewName} from "module/selpan/menu/FieldDictSelectHelper";

export const FavOrderEntryView = Backbone.View.extend({
	className: 'FavOrderEntryView',
	events: {
		'click [data-favorderentryview="destroyModel"]': 'destroyModel',
		'click [data-favorderentryview="toggleDirection"]': 'toggleDirection',
		'change': 'parseForm'
	},
	initialize: function (options) {
		_.bindAll(this, _.functionsIn(this));
		this.selpan = options.selpan;
		this.listenTo(this.model, 'change:desc', this.render);
		this.selpan.FieldDictP.then(this.render);
	},
	destroyModel: function () {
		this.model.destroy();
	},
	parseForm: function () {
		let mergedFieldName = this.$('select').val();
		let cid = fromViewName(mergedFieldName);
		this.model.set({
			field: cid.field,
			dq2Value: cid.dq2Value
		});
	},
	toggleDirection: function () {
		this.model.set({desc: !this.model.get('desc')});
	},
	template: _.template('<div class="MenuInline" data-id="<%= m.cid %>">\n\t<div class="MenuRight MenuItemPassive MenuButton" data-favorderentryview="destroyModel">\n\t\t<i class="fa fa-times"></i>\n\t</div>\n\t<div class="MenuRight MenuItemPassive MenuButton" title="Sortierung umkehren" data-favorderentryview="toggleDirection">\n\t\t<i class="fa <%= m.get(\'desc\') ? \'fa-chevron-down\' : \'fa-chevron-up\'%>"></i>\n\t</div>\n\t<select data-role="none" class="MenuSelect MenuInline">\n\t\t<option></option>\n\t\t<% _.each(dict, function(f){ %>\n\t\t<option value="<%= toViewName(f.entityField, f.dq2Value) %>"><%= f.label %></option>\n\t\t<% }); %>\n\t</select>\n\n</div>'),
	render: function () {
		this.$el.html(this.template({
			m: this.model,
			dict: this.selpan.FieldDict.getSortableFields(),
			toViewName: toViewName
		}));
		this.$('select').val(toViewName(this.model.get('field'), this.model.get('dq2Value')));
	}
});

export const FavOrderManageView = ManageView.extend({
	className: 'FavOrderManageMenuView',
	ChildView: FavOrderEntryView,
	templateHeader: _.template('<div class="CollapsibleToggleRegion MenuItemPassive MenuButton" title="Sortierung für aktuellen Favoriten bearbeiten">\n\t<div class="MenuInline MenuIcon"><i class="fa fa-sort"></i></div>\n\t<div class="MenuInline MenuLabel">Sortierung</div>\n</div>')
});